export default __webpack_public_path__ + "static/screenSecondSectionRu-5439904df1d9689522bb1d86fa1ea21e.webp";